export enum ReceiveSummaryEnum {
  Unknown = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 4,
}
